module.exports = __webpack_public_path__ + "static/media/absensi_rekap.76b9917a.png";